module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS1.7909711d.jpg";